export default "__VITE_ASSET___j4z0rO0__"